import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  FormControl,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure
} from "@chakra-ui/react";


export default function EntryForm({
  taskInput,
  descriptionInput,
  durationInput,
  importanceInput,
  anxietyInput,
  repeatingInput,
  date_dueInput,
  task_default,
  description_default,
  duration_default,
  importance_default,
  anxiety_default,
  repeating_default,
  date_due_default  }) {

  return (<FormControl >
    <Input
      pr="4.5rem"
      type="text"
      name="task"
      defaultValue={task_default}
      placeholder="Task"
      aria-label="Add task"
      ref={taskInput}
    />
    <Input
      pr="4.5rem"
      type="text"
      name="description"
      defaultValue={description_default}
      placeholder="Description"
      aria-label="Add description"
      ref={descriptionInput}
    />
    <Input
      pr="4.5rem"
      type="number"
      name="duration"
      defaultValue={duration_default}
      placeholder="Duration (minutes)"
      aria-label="Add duration"
      ref={durationInput}
    />
    <Input
      pr="4.5rem"
      type="number"
      name="importance"
      defaultValue={importance_default}
      placeholder="Importance (out of 10))"
      aria-label="Add importance"
      ref={importanceInput}
    />
    <Input
      pr="4.5rem"
      type="number"
      name="anxiety"
      defaultValue={anxiety_default}
      placeholder="Anxiety (out of 10)"
      aria-label="Add anxiety"
      ref={anxietyInput}
    />
    <Input
      pr="4.5rem"
      type="number"
      name="repeating"
      defaultValue={repeating_default}
      placeholder="Repeating interval (minutes)"
      aria-label="Add repeating"
      ref={repeatingInput}
    />
    <Input
      pr="4.5rem"
      type="datetime-local"
      name="date_due"
      defaultValue={date_due_default}
      placeholder="Add due date"
      aria-label="Add due date"
      ref={date_dueInput}
    />
  </FormControl>)
}